import get from 'lodash/get';
import isArray from 'lodash/isArray';
import { getAppData, allowed } from '@/utils';
import alertGetters from 'optinmonster-js-library/src/vue/campaigns/store/alerts/getters';

const getFromList = (state, thing, check) => {
	return isArray(check) ? check.some((k) => state[thing].includes(k)) : state[thing].includes(check);
};
const getters = {
	...alertGetters,
	userId: (state) => state.user.id,
	connected: (state) => Boolean(state.user.id && state.apiKey),
	shouldFetchUser: (state) => Boolean(state.apiKey && state.apiKeyValid && !state.user.created),
	userAttribute: (state) => (key, fallback) => get(state, `user.${key}`, fallback),
	isLoading: (state) => (key) => getFromList(state, 'loading', key),
	isFetching: (state) => (key) => getFromList(state, 'fetching', key),
	isFetched: (state) => (key) => getFromList(state, 'fetched', key),
	userEmail: (state, getters) => getters.userAttribute('email'),
	userFirstName: (state, getters) => getters.userAttribute('firstName'),
	userLastName: (state, getters) => getters.userAttribute('lastName'),
	userLevel: (state, getters) => getters.userAttribute('level'),
	topTier: (state, getters) => getters.userAttribute('topTier'),
	isLiteUser: (state, getters) => 'vbp_free' === getters.userLevel,
	upgradeGrowth: (state, getters) => 'vbp_pro' === getters.userLevel,
	userPlanName: (state, getters) => {
		return getters.isLiteUser ? 'OptinMonster Lite' : getters.userAttribute('planName');
	},
	features: (state, getters) => {
		let features = getters.userAttribute('features', []);

		// If features exist in the app data, just use those.
		return features && isArray(features) ? features : getAppData('features');
	},
	allowed: (state) => (category, permission, resource) => {
		return allowed(state.user, category, permission, resource);
	},
	hasFeature: (state) => (feature) => {
		return allowed(state.user, 'features', feature);
	},
	hasRuleType: (state) => (ruleType) => {
		return allowed(state.user, 'ruleTypes', ruleType);
	},
	hasIntegration: (state) => (integration) => {
		return allowed(state.user, 'integrations', integration);
	},
	showProUpsells: (state, getters) => getters.isLiteUser || !getters.connected,
	proUpsellPlan: (state, getters) => (getters.upgradeGrowth ? 'Growth' : 'Pro'),
	hasSiteError: (state) => !!state.alerts.find((a) => get(a, 'meta.verifySiteChange', false)),
	showReview: (state) => state.showReview,
	userTimezone: (state) => getAppData('timezone', get(state, 'user.timezone')),
	adjustUserTimezone: (state, getters) => (moment) => {
		if (getters.userTimezone) {
			moment = moment.utc(moment.valueOf()).tz(getters.userTimezone);
		}

		return moment;
	},
};

const onboardingMap = {
	onboardingVia: 'via',
	onboardingGoal: 'goal',
	onboardingUsage: 'usage',
	onboardingUsageOtherText: 'usage_other_text',
	onboardingEmailList: 'email_list',
	onboardingEmailService: 'email_service',
	onboardingEmailServiceOtherText: 'email_service_other_text',
};

Object.keys(onboardingMap).forEach((getter) => {
	const key = onboardingMap[getter];
	getters[getter] = (state) => {
		return get(state, `user.onboarding.${key}`);
	};
});
const onboardingConditionalMap = {
	onboardingUsageOtherText: ['usage_other_text', 'usage', 'other'],
	onboardingEmailServiceOtherText: ['email_service_other_text', 'email_service', 'other'],
};

Object.keys(onboardingConditionalMap).forEach((getter) => {
	const [key, conditionalKey, conditionalValue] = onboardingConditionalMap[getter];
	getters[getter] = (state) => {
		return conditionalValue === get(state, `user.onboarding.${conditionalKey}`)
			? get(state, `user.onboarding.${key}`)
			: '';
	};
});
export default getters;
